var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zwx-headline"},[_c('div',{staticClass:"zwx-head-title"},[_c('i',{staticClass:"zwx-head-title-line"}),_c('span',{class:_vm.required},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }